<template>
    <div class="results">
        <div class="row">
            <div class="col-sm-4">
                <b>{{ "App.Ajoneuvoverolaskuri.Results.Daily" | translate }}</b>
            </div>
            <div class="col-sm-4">
                <b>{{ "App.Ajoneuvoverolaskuri.Results.Yearly" | translate }}</b>
            </div>
            <div class="col-sm-4">
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                {{ formatTaxValue(basicTaxDaily) }} €
            </div>
            <div class="col-sm-4">
                {{ formatTaxValue(basicTaxDaily * yearlyFactor) }} €
            </div>
            <div class="col-sm-4">
                <b>{{ "App.Ajoneuvoverolaskuri.Results.BasicTax" | translate }}</b>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                {{ formatTaxValue(powerTaxDaily) }} €
            </div>
            <div class="col-sm-4">
                {{ formatTaxValue(powerTaxDaily * yearlyFactor) }} €
            </div>
            <div class="col-sm-4">
                <b>{{ "App.Ajoneuvoverolaskuri.Results.PowerTax" | translate }}</b>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                {{ formatTaxValue(basicTaxDaily + powerTaxDaily) }} €
            </div>
            <div class="col-sm-4">
                {{ formatTaxValue((basicTaxDaily * yearlyFactor) + (powerTaxDaily * yearlyFactor)) }} €
            </div>
            <div class="col-sm-4">
                <b>{{ "App.Ajoneuvoverolaskuri.Results.Summary" | translate }}</b>
            </div>
        </div>
        <p class="calculatorInfoParagraph">{{ "App.Ajoneuvoverolaskuri.Information.ResultsNotBinding" | translate}}</p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-property-decorator"

    @Component
    export default class ResultsTable extends Vue {
        @Prop({ default: 0.0 }) readonly basicTaxDaily!: number
        @Prop({ default: 0.0 }) readonly yearlyFactor!: number
        @Prop({ default: 0.0 }) readonly powerTaxDaily!: number

        formatTaxValue(value: number): string {
            const langId = this.$store.getters.activeLang
            return value.toLocaleString(langId, { minimumFractionDigits: 3, maximumFractionDigits: 3 })
        }
    }
</script>

<style scoped>
    .results {
        max-width: 700px
    }

    .results .row:last-child {
        border-top: 1px solid black;
        margin-top: 3px;
        padding-top: 3px;
    }

    .calculatorInfoParagraph {
        text-align: center;
        font-size: 0.7rem;
        margin-top: 10px;
    }
</style>
